module.exports = __webpack_public_path__ + "static/img/zip.839d61e0.svg";